import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import iptrackerdetailsv2 from '../../../iptrackerdetails'
import CryptoJS from 'crypto-js';
import moment from 'moment'


import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'user',
  components: {
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data: function() {
    return {
      username: '',
      userid: '',
      olduserid: '',
      resultCount: false,
      isLoading: false,
      isINHLoader: false,
      isPasswordLoader: false,
      userdata: {},
      outsource: [],
      updatePasswordModal: false,
      forcedLogoutmodalShow: false,
      projectModal: false,
      closeforcedLogoutModal: false,
      logOutDevice: '',
      projectLoader:false,
      projectList:[],
      isTokenLoader:false,
      isLoginChecked:false,
      UsermasterHubs : [],
      LiveHubs : [],
    }
  },
  created: function() {

  },
  filters: {
    gmttoist: function (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
  }
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.iptrackData = userdetail;
    let iptrck= await iptrackerdetailsv2.checkUserIPV2(this.iptrackData,'UserDetails view',this.$route.path);
    //console.log(iptrck);
    if(iptrck){
      this.$router.push('/');
    }
    this.localusermailid = userdetail.email;
  },
  methods: {
    searchUserData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        username: this.username,
        olduserid: this.olduserid,
        userid: this.userid
      })
      this.isLoading = true
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getUserComparedData',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (result.data.length > 0) {
            this.userdata = result.data[0]
            if(this.userdata.HubId){
              (this.userdata.HubId.length) ? this.fetchHubDetails(this.userdata.HubId,'UM') : ''
            }
            if (this.userdata.liveusermaster.livehubid) {
              let livehubs = []
              livehubs.push(this.userdata.liveusermaster.livehubid.split(','))
              this.fetchHubDetails(livehubs[0],'LM')
            }
            this.resultCount = true
            this.isLoading = false
          } else {
            this.$alertify.error("No user details found for the given search criteria")
            this.isLoading = false
          }
        })
    },
    resetForm() {
      this.username = ''
      this.userid = ''
      this.olduserid = ''
      this.resultCount = false
    },
    getOutSourcingEntityType(OutSourcingID) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      if (OutSourcingID == null || OutSourcingID == 'undefined') {
        this.$alertify.alert("","Null outsource ID")
      } else {
        this.outsource.push(OutSourcingID)
        this.input = {
          OutSourcingMasterID: this.outsource,
          EntityType: "INHAgent"
        }
        this.isINHLoader = true;
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'external/getOutSourcingEntityType',
          headers: {
            'Authorization': 'Bearer ' + myStr
          },
          data: this.input,
        }).then(result => {
          this.isINHLoader = false
          if (result.data.data.code == 200) {
            this.$alertify.alert("","INH Agent")
          }
          if (result.data.data.code == 204)
            this.$alertify.alert("","Not an INH Agent")
        })
      }

    },
    getforcedLogoutRowData(userid, logOutDevice) {
      this.forcedLogoutmodalShow = true
      this.userid = this.userdata.userid
      this.logOutDevice = logOutDevice
    },
    forcedLoggoutUser() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'forcedloggoutuser',
          'data': {
            'userid': this.userid,
            'logoutdevice': this.logOutDevice,
            'modifiedby': this.localusermailid
          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then((response) => {
          if (response.data.errorCode == 0) {
            this.$alertify.success(response.data.msg);
            this.forcedLogoutmodalShow = false;
            window.location.reload()
          } else if (response.data.errorCode == -1) {
            this.$alertify.error(response.data.msg)
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    updatePasswordString(userid, passwrd) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      if (passwrd == null || passwrd == 'undefined' || passwrd == '') {
        this.$alertify.error("No password in DMS")
      } else {
        this.isPasswordLoader = true
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'updatePasswordString',
          'data': {
            'userid': userid,
            'newpassword': passwrd
          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        }).then(result => {
          if (result.data.code == 200) {
            this.isPasswordLoader = false
            this.$alertify.success(result.data.msg)
          } else {
            this.isPasswordLoader = false
            this.$alertify.error(result.data.msg)
          }
        }).catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
      }
    },

    getProjectsByType(utype){
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        usertype: utype
      });
      this.projectModal = true;
      this.projectLoader = true
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTypeWiseProjectRoleList',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
      .then(result => {
        this.projectList = result.data
        this.projectLoader = false
      })
    },
    closeProjectModal(){
      this.projectModal = false
    },
    redirectToLogin(appurl){
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        username: this.userdata.username,
        password: this.userdata.liveusermaster.livepassword,
        appkey: appurl
      });
      this.isLoginChecked = true
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'userauth/getusertoken',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
      .then(result => {
        if (result.data.code == 200) {
          this.$alertify.success("Login check successful!")
        }
        else {
          this.$alertify.error(result.data.error)
        }

        this.isLoginChecked = false
      })
    },
    fetchHubDetails(hubs,flagVar){
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        hubids :  hubs
      })
      this.hubLoading = true
      axios({
        method : 'POST',
        'url' : apiUrl.api_url + 'external/getHubDetails',
        data : this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      }).then(result => {
        if(result.data.code == 100){
          let hubList = []
        for (let index = 0; index < result.data.data.length; index++) {
          hubList[index] = result.data.data[index].HubName + '(' + result.data.data[index].HubID + ')'
        }
        (flagVar == 'LM') ? this.LiveHubs = hubList : this.UsermasterHubs = hubList
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/userdetailtableview/userdetailtableview.component.js